"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateScheduleAvailabilityDto = instanceOfUpdateScheduleAvailabilityDto;
exports.UpdateScheduleAvailabilityDtoFromJSON = UpdateScheduleAvailabilityDtoFromJSON;
exports.UpdateScheduleAvailabilityDtoFromJSONTyped = UpdateScheduleAvailabilityDtoFromJSONTyped;
exports.UpdateScheduleAvailabilityDtoToJSON = UpdateScheduleAvailabilityDtoToJSON;
exports.UpdateScheduleAvailabilityDtoToJSONTyped = UpdateScheduleAvailabilityDtoToJSONTyped;
const UpdateScheduleAvailabilityDateDto_1 = require("./UpdateScheduleAvailabilityDateDto");
/**
 * Check if a given object implements the UpdateScheduleAvailabilityDto interface.
 */
function instanceOfUpdateScheduleAvailabilityDto(value) {
    if (!('dates' in value) || value['dates'] === undefined)
        return false;
    return true;
}
function UpdateScheduleAvailabilityDtoFromJSON(json) {
    return UpdateScheduleAvailabilityDtoFromJSONTyped(json, false);
}
function UpdateScheduleAvailabilityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'dates': (json['dates'].map(UpdateScheduleAvailabilityDateDto_1.UpdateScheduleAvailabilityDateDtoFromJSON)),
    };
}
function UpdateScheduleAvailabilityDtoToJSON(json) {
    return UpdateScheduleAvailabilityDtoToJSONTyped(json, false);
}
function UpdateScheduleAvailabilityDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'dates': (value['dates'].map(UpdateScheduleAvailabilityDateDto_1.UpdateScheduleAvailabilityDateDtoToJSON)),
    };
}
//# sourceMappingURL=UpdateScheduleAvailabilityDto.js.map